const createReplaceCardSlice = (set, _get) => ({
    replacedCardholders: [],
    updateReplacedCardholders: replacedCardholders => set({
        replacedCardholders
    })
});
export default createReplaceCardSlice;
//# sourceMappingURL=replaceCardSlice.js.map